import { useLuminaireMetric } from './useLuminaires'
import { LuminaireMetricFilter } from '../types/luminaire.types'

export const useLuminaireActivePower = (devEui: string, filter: LuminaireMetricFilter) => {
  const activePowerQuery = useLuminaireMetric('active_power', { ...filter, devEui })
  return { filter, activePowerQuery }
}

export const useLuminairePowerFactor = (devEui: string, filter: LuminaireMetricFilter) => {
  const powerFactorQuery = useLuminaireMetric('power_factor', { ...filter, devEui })
  return { filter, powerFactorQuery }
}

export const useLuminaireActiveEnergy = (devEui: string, filter: LuminaireMetricFilter) => {
  const activeEnergyQuery = useLuminaireMetric('active_energy', { ...filter, devEui })
  return { filter, activeEnergyQuery }
}

export const useLuminaireDimmingLevel = (devEui: string, filter: LuminaireMetricFilter) => {
  const dimmingLevelQuery = useLuminaireMetric('dimming_level', { ...filter, devEui })
  return { filter, dimmingLevelQuery }
}

export const useLuminaireDownlinkRssi = (devEui: string, filter: LuminaireMetricFilter) => {
  const downlinkRssiQuery = useLuminaireMetric('downlink_rssi', { ...filter, devEui })
  return { filter, downlinkRssiQuery }
}

export const useLuminaireActiveAlerts = (devEui: string, filter: LuminaireMetricFilter) => {
  const { data, isLoading, isError } = useLuminaireMetric('active_alerts', { ...filter, devEui })
  return { data, isLoading, isError }
}

export const useLuminaireFirmwareVersion = (devEui: string, filter: LuminaireMetricFilter) => {
  const { data, isLoading, isError } = useLuminaireMetric('firmware_version', { ...filter, devEui })
  return { data, isLoading, isError }
}
